export const meta = {
  title: '服务条款 | Firefly Wedding',
  description: '使用非官方 Firefly Wedding 粉丝站及其链接与内容的条款。',
  updated_at: '2026-10-14',
};

## 使用 Firefly Wedding

Firefly Wedding（fireflywedding.org）是一个非官方、非商业的《ホタルの嫁入り（萤火之嫁）》漫画与动画粉丝站。使用本站即表示你同意以下条款。

## 并非官方来源

本站与小学馆、橘オレコ、david production、富士电视台及任何流媒体平台均无关联。播出时间、声优、发售日期和平台上线情况均整理自公开报道，可能变动，请以每条信息所附的官方来源为准。动画官方网站为 [hotaru-anime.com](https://hotaru-anime.com/)。

## 知识产权

《ホタルの嫁入り》及其角色、名称与美术作品归各自权利人所有。本站展示的官方美术（如主视觉、漫画封面与角色立绘）归其权利人所有，仅用于标识作品；其余插图为原创装饰性作品。简短的事实信息仅用于评论与参考。如你是权利人并希望修改相关内容，请发送邮件至 [support@fireflywedding.org](mailto:support@fireflywedding.org)，我们会尽快处理。

## 外部链接

我们链接第三方平台，帮助粉丝找到合法的观看与阅读渠道。我们无法控制这些服务，也不对其内容、价格或地区可用性负责。本站绝不链接未经授权的盗版资源。

## 账号

如你注册账号，请妥善保管登录信息，不得利用本站骚扰他人、发送垃圾信息或从事违法活动，否则我们可能停用相关账号。

## 免责声明

本站按"现状"提供，不作任何保证。在法律允许范围内，我们不对因使用本站造成的损失承担责任。

## 条款变更

我们可能更新本条款；更新后继续使用本站即视为接受新版本。
